import { Component,
    OnInit,
    ElementRef,
    Output,
    EventEmitter,
    ChangeDetectorRef,
    AfterViewInit,
    ViewChild} from '@angular/core';
import { GameService } from '../../services/game.service';
import { GameStresshoofd, GameStresshoofdOption } from '../../_models/model';
import { Router, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';
import { AudioPlayerService } from '../../services/audio-player.service';
import { IGameComponent } from '../game/game.component';

@Component({
    selector: 'app-game-stresshead',
    templateUrl: './game-stresshead.component.html',
    styleUrls: ['./game-stresshead.component.less']
})
export class GameStressheadComponent implements OnInit, AfterViewInit, IGameComponent  {
    @Output() closeEvent = new EventEmitter<boolean>();
    private activeGame?: GameStresshoofd;
    public firstStressMeterDone?: boolean;
    private progressData = '';

    @ViewChild('rangesliderReference', { static: true })
    rangesliderReference!: ElementRef;

    // Bindable properties
    public explanationText?: string;
    public measureText?: string;
    public options: GameStresshoofdOption[] = [];
    public angerLevel: number = 0;
    public howStressed?: string;

    public showStressMeter = true;

    // Used to indicate the progress
    public progressBarData:
    {
        optionId: number,
        pressed: boolean;
    }[] = [];
    progressBarDomManipulationDone: boolean | undefined;


    constructor(
        private gameService: GameService,
        private router: Router,
        private route: ActivatedRoute,
        private _changeDetectionRef: ChangeDetectorRef,
        public audio: AudioPlayerService) { }

    public setGame(game: GameStresshoofd) {
        this.activeGame = game;
        this.options = this.shuffleArray(this.activeGame.options);
        this.explanationText = this.activeGame.explanation.text;
        this.measureText = this.activeGame.measure.text;
        this.howStressed = this.audio.get('hoe_gestresst');
        this.audio.playAudio(this.activeGame.measure, () => this.audio.play('hoe_gestresst'));

        for (let optionId = 0; optionId < this.activeGame.options.length; optionId++) {
            this.progressBarData.push({optionId: optionId, pressed: false});
        }
        this.calculateAngerLevel();

    }

    // Note: option is of type progressBarData!
    selectOption(option: any) {
        if (this.progressBarData[option.optionId].pressed === false) {
            this.progressBarData[option.optionId].pressed = true;
        } else {
            this.progressBarData[option.optionId].pressed = false;
        }

        // if (((this.options[option.optionId].optionResult.toString()) === 'bad' && option.pressed) ||
        //     ((this.options[option.optionId].optionResult.toString()) === 'good' && !option.pressed)) {
        //     this.audio.playError();
        // } else {
        //     this.audio.playSuccess();
        // }
        this.audio.cancelAll();
        this.audio.playAudio(this.options[option.optionId].optionText);

        this.calculateAngerLevel();
    }

    public finishSelecting() {
        this.showStressMeter = true;
        this.audio.play('hoe_gestresst');

        this.progressBarDomManipulationDone = false;
    }

    public finishStressMeter() {
      if (!this.activeGame) {
        throw Error('no active game found');
      }
        if (this.firstStressMeterDone) {
            this.gameService.setLevelProgress(this.activeGame.levelElement.uuid, this.progressData, true);
            this.closeEvent.emit();
        } else {
            this.audio.playAudio(this.activeGame.explanation);
            this.showStressMeter = false;
            this.firstStressMeterDone = true;
        }
    }

    private calculateAngerLevel() {
        let angerLevel = 0;
        for (let optionId = 0; optionId < this.options.length; optionId++) {
            // Get current option id;
            const option = this.progressBarData.find(x => x.optionId === optionId);

            if (((this.options[optionId].optionResult.toString()) === 'bad' && option?.pressed) ||
                ((this.options[optionId].optionResult.toString()) === 'good' && !option?.pressed)) {
                angerLevel++;
            }
        }
        this.angerLevel = angerLevel;
    }

    ngOnInit(): void {


    }


    // ngAfterViewChecked(): void {
    //     // Dirty hack to do dom manipulation again after the ngIf removed and then again set the
    //     if (!this.progressBarDomManipulationDone) {
    //         this.setProgressBar();
    //         this.progressBarDomManipulationDone = true;
    //     }
    // }

    ngAfterViewInit(): void {
        this.setProgressBar();
    }

    private setProgressBar(): void {
      const rangeSliderEl = $(this.rangesliderReference.nativeElement) as any;
      rangeSliderEl.rangeslider({
            polyfill: false,
            onInit: function() {
                $('.header .pull-right').text($('input[type="range"]').val() + 'K');
            },
            onSlide: function(position: number, value: any) {

                $('.header .pull-right').text(value + 'K');
            },
            onSlideEnd: function(position: number, value: any) {
            }
        });
    }
    // https://stackoverflow.com/questions/3718282/javascript-shuffling-objects-inside-an-object-randomize
    private shuffleArray(sourceArray: any[]) {
        for (let i = 0; i < sourceArray.length - 1; i++) {
            const j = i + Math.floor(Math.random() * (sourceArray.length - i));
            const temp = sourceArray[j];
            sourceArray[j] = sourceArray[i];
            sourceArray[i] = temp;
        }
        return sourceArray;
    }
}
